import { useMemo } from 'react';

export function useIsDesktop() {
  return useMemo(() => window.matchMedia('(min-width: 1080px)').matches, []);
}
